module.exports = __webpack_public_path__ + "fonts/poppins-semibolditalic-webfont.2c575f0e.woff";